import { TextEllipsisStaticLine } from '../../../../../common/textEllipsis/TextEllipsisStaticLine'

export const Label = ({ isActive, label, style, isChildren }) => {
  return (
    <TextEllipsisStaticLine
      text={label}
      lineClamp={2}
      appendStyle={{
        ...style,
        color: isActive ? '#FFFFFF' : '#191D25',
        fontWeight: !isChildren || isActive ? 600 : 400,
      }}
    />
  )
}
